import ContentStorage from '../../tnew/content/ContentStorage';

function getValue(name: string) {
  return ContentStorage.getValue('a349395d-5724-4fba-8bc7-904f10f1e2ed', name);
}

class EventsListingPageComponent {
  static get screenReaderProcessingRequestMessage() {
    return getValue('ScreenReaderProcessingRequestMessage');
  }

  static get screenReaderProcessingRequestCompleteMessage() {
    return getValue('ScreenReaderProcessingRequestCompleteMessage');
  }
}

export default EventsListingPageComponent;
